<template>
	<div>
		<v-container>
			<v-card>
				<v-card-text>
					<v-row no-gutters>
						<v-col cols="12">
							<v-card flat>
								<v-card-title class="title">
									<strong>Patient Profile</strong>
								</v-card-title>
								<v-card-text v-if="user" class="black--text">
									Patient ID: {{ user.id }}
									<br />
									Name: {{ user.name }}
									<br />
									Date of Birth: {{ user.birth }}
									<br />
									Age: {{ user.age }}
									<br />
									Gender: {{ user.gender }}
									<br />
									Clinic: {{ user.Clinic }}
									<br />
									Nationality: {{ user.Nationality }}
									<br />
									Cellphone: {{ user.cellphone }}
									<template v-if="user.phone && user.phone != 'null'">
										<br />
										Phone: {{ user.phone }}
									</template>
									<br />
									Email: {{ user.email }}
								</v-card-text>
							</v-card>
						</v-col>

						<v-col cols="12">
							<v-card flat>
								<v-card-title class="title">
									<strong>Appointments history</strong>
								</v-card-title>
								<v-card-text class="black--text">
									<v-data-table
										:headers="headers"
										:items="appointments"
										:loading="loading"
										multi-sort
										hide-default-footer
									>
										<template v-slot:item.name="{ item }">
											<v-tooltip bottom>
												<template v-slot:activator="{ on }">
													<a v-on="on" @click="openProfile(item)">{{ item.name }}</a>
												</template>

												<span>View profile</span>
											</v-tooltip>
										</template>

										<template v-slot:item.attend="{ item }">
											<v-switch v-model="item.attend" hide-details color="primary"></v-switch>
										</template>

										<template v-slot:item.status="{ item }">
											<div
												:class="{'success--text':item.status=='New Appointment','error--text':item.status=='Past Due'}"
											>
												<template>{{ item.status }}</template>
											</div>
										</template>

										<template v-slot:item.stage="{ item }">
											<div>{{ item.stage }}</div>
										</template>

										<template v-slot:item.actions="{ item }">
											<span style="white-space: nowrap;">
												<v-tooltip bottom>
													<template v-slot:activator="{ on }">
														<v-icon color="primary" v-on="on" @click="openMedicalInfo(item.id)">mdi-open-in-new</v-icon>
													</template>

													<span>Show</span>
												</v-tooltip>

												<v-tooltip bottom>
													<template v-slot:activator="{ on }">
														<v-icon
															color="secondary"
															v-on="on"
															@click="openGrading(item.id)"
														>mdi-file-document-outline</v-icon>
													</template>

													<span>Grading</span>
												</v-tooltip>

												<v-tooltip bottom>
													<template v-slot:activator="{ on }">
														<v-icon color="secondary" v-on="on" @click="openReport(item.id)">mdi-file-chart</v-icon>
													</template>

													<span>Report</span>
												</v-tooltip>
											</span>
										</template>
									</v-data-table>
								</v-card-text>
								<v-card-actions v-if="length">
									<v-col class="text-center" cols="12">
										<v-pagination v-model="page" :length="length" circle color="primary"></v-pagination>
									</v-col>
								</v-card-actions>
							</v-card>
						</v-col>

						<v-col cols="12">
							<v-row class="text-center" justify="center" dense>
								<v-col class="shrink">
									<v-btn color="success" class="text-none" rounded @click="openNewAppointment">New Appontment</v-btn>
								</v-col>
								<v-col class="shrink">
									<v-btn color="primary" class="text-none" rounded outlined @click="openPersonal">Edit</v-btn>
								</v-col>
								<!-- <v-flex shrink>
									<v-btn color="secondary" class="text-none" rounded outlined @click="openReport">Report</v-btn>
								</v-flex>
								<v-flex shrink>
									<v-btn color="secondary" class="text-none" rounded outlined @click="openScanning">Scan</v-btn>
								</v-flex>-->
								<v-col class="shrink">
									<v-btn color="error" class="text-none" rounded outlined @click="openHome">Back</v-btn>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-container>
	</div>
</template>

<script>
const axios = require("axios");

export default {
	components: {
		// "app-eye-doc-stepper": require("@/components/steppers/AppEyeDocStepper.vue")
		// 	.default
	},
	mixins: [
		require("@/mixins/backend-mixin").default,
		require("@/mixins/router-mixin").default
	],
	data() {
		return {
			headers: [
				{
					text: "#",
					align: "left",
					value: "id"
				},
				{
					text: "State",
					align: "left",
					value: "state"
				},
				{
					text: "Camera Man",
					align: "left",
					value: "camera_man"
				},
				{
					text: "Eye Specialist",
					align: "left",
					value: "eye_specialist"
				},
				{
					text: "Date",
					align: "left",
					value: "date"
				},
				{
					text: "Time",
					align: "left",
					value: "time"
				},
				{
					text: "Stage",
					align: "left",
					value: "stage"
				},
				{
					text: "Actions",
					align: "center",
					value: "actions",
					sortable: false
				}
			],
			user: {},
			appointments: [],
			page: 1,
			length: null,
			loading: false
		};
	},
	watch: {
		page(newVal) {
			this.appointments = [];
			this.loading = true;
			this.getAppointments(newVal);
		}
	},
	mounted() {
		this.fetchData();
	},
	methods: {
		fetchData() {
			this.getDate();
			this.getAppointments(1);
		},
		getDate() {
			var id = this.$route.params.patientId;

			const url = this.BACKEND_URL + "/api/getUserById/" + id;
			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						thisVue.user = response.data;
						thisVue.user.id = thisVue.user.nationalId;
						thisVue.user.name =
							thisVue.user.FirstName +
							" " +
							thisVue.user.FatherName +
							" " +
							thisVue.user.FamilyName;
						thisVue.user.age =
							thisVue.getAge(thisVue.user.birth) + " Years";
						var clinicId = response.data.Clinic;
						thisVue.user.Clinic = "";
						thisVue.getClinicName(clinicId);
						thisVue.user.Nationality = "";
						thisVue.getNationality(thisVue.user.id);
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		getAppointments(page) {
			var id = this.$route.params.patientId;

			const url =
				this.BACKEND_URL +
				"/api/appointmentForPatient/" +
				id +
				"?page=" +
				page;
			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						thisVue.loading = false;
						thisVue.length = response.data.meta.last_page;
						thisVue.appointments = response.data.data.map(item => {
							item.state = item.state.description;
							item.stage = item.stage.description;
							item.time = item.time1;
							item.camera_man =
								item.user.FirstName +
								" " +
								item.user.FamilyName;
							item.eye_specialist =
								item.doc.FirstName + " " + item.doc.FamilyName;
							return item;
						});
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		getClinicName(id) {
			const url = this.BACKEND_URL + "/api/getClinicById/" + id;

			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						var clinic = response.data;
						thisVue.user.Clinic = clinic.description;
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		getNationality(id) {
			const url = this.BACKEND_URL + "/api/findNationlityByUserID/" + id;

			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						var nationality = response.data;
						thisVue.user.Nationality = nationality.description;
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		openScanning() {
			this.$router.push("/patient-med-info/" + "SOMETHING");
		},
		openReport(appointmentId) {
			this.$router.push("/report/" + appointmentId);
		},
		openPersonal() {
			var id = this.user.id;
			this.$router.push("/patient-update/" + id);
		},
		openNewAppointment() {
			var id = this.user.id;
			this.$router.push("/new-appointment/" + id);
		},
		openHome() {
			this.$router.push("/eye-doc");
		},
		getAge(dateString) {
			console.log(dateString);
			var today = new Date();
			var birthDate = new Date(dateString);
			var age = today.getFullYear() - birthDate.getFullYear();
			var m = today.getMonth() - birthDate.getMonth();
			if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
				age--;
			}
			return age;
		},
		openMedicalInfo(appointmentId) {
			this.$router.push("/patient-med-info/" + appointmentId);
		},
		openGrading(appointmentId) {
			this.$router.push("/grading/" + appointmentId);
		}
	}
};
</script>

<style scoped>
.v-data-table td,
.v-data-table th {
	padding: 0 !important;
}
</style>
